import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Session } from './../entities/session';
import { catchError } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  private baseUrl = environment.apiUrl + '/api/session/';
  basic: string | string[];

  constructor(private http: HttpClient) { }

  addSession(session: Session): Observable<Session> {
    return this.http.post<Session>(this.baseUrl, session);
  }

  updateSession(sessionId: number, session: Session): Observable<any> {
    return this.http.put<Session>(`${this.baseUrl} ${ sessionId }`, session , httpOptions)
      .pipe(
      catchError(this.handleError<any>('updateSession'))
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
}

